module.exports = __WEBPACK_EXTERNAL_MODULE_gNLg__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"immutable","commonjs2":"immutable","amd":"immutable","root":"Immutable"}
// module id = gNLg
// module chunks = 0